const ticketsOverview = [
    {
        datetime: "2024-05-03 00:00:00",
        todo: {
            issues: 5,
            points: 0,
        },
        inProgress: {
            issues: 5,
            points: 0,
        },
        done: {
            issues: 0,
            points: 0,
        },
        todoAll: {
            issues: 5,
            points: 0,
        },
        inProgressAll: {
            issues: 5,
            points: 0,
        },
        doneAll: {
            issues: 173,
            points: 0,
        },
    },
    {
        datetime: "2024-05-04 00:00:00",
        todo: {
            issues: 5,
            points: 0,
        },
        inProgress: {
            issues: 5,
            points: 0,
        },
        done: {
            issues: 0,
            points: 0,
        },
        todoAll: {
            issues: 5,
            points: 0,
        },
        inProgressAll: {
            issues: 5,
            points: 0,
        },
        doneAll: {
            issues: 173,
            points: 0,
        },
    },
    {
        datetime: "2024-05-05 00:00:00",
        todo: {
            issues: 5,
            points: 0,
        },
        inProgress: {
            issues: 5,
            points: 0,
        },
        done: {
            issues: 0,
            points: 0,
        },
        todoAll: {
            issues: 5,
            points: 0,
        },
        inProgressAll: {
            issues: 5,
            points: 0,
        },
        doneAll: {
            issues: 173,
            points: 0,
        },
    },
    {
        datetime: "2024-05-06 00:00:00",
        todo: {
            issues: 5,
            points: 0,
        },
        inProgress: {
            issues: 5,
            points: 0,
        },
        done: {
            issues: 0,
            points: 0,
        },
        todoAll: {
            issues: 5,
            points: 0,
        },
        inProgressAll: {
            issues: 5,
            points: 0,
        },
        doneAll: {
            issues: 173,
            points: 0,
        },
    },
    {
        datetime: "2024-05-07 00:00:00",
        todo: {
            issues: 5,
            points: 0,
        },
        inProgress: {
            issues: 5,
            points: 0,
        },
        done: {
            issues: 0,
            points: 0,
        },
        todoAll: {
            issues: 5,
            points: 0,
        },
        inProgressAll: {
            issues: 5,
            points: 0,
        },
        doneAll: {
            issues: 173,
            points: 0,
        },
    },
    {
        datetime: "2024-05-08 00:00:00",
        todo: {
            issues: 5,
            points: 0,
        },
        inProgress: {
            issues: 5,
            points: 0,
        },
        done: {
            issues: 0,
            points: 0,
        },
        todoAll: {
            issues: 5,
            points: 0,
        },
        inProgressAll: {
            issues: 5,
            points: 0,
        },
        doneAll: {
            issues: 173,
            points: 0,
        },
    },
    {
        datetime: "2024-05-09 00:00:00",
        todo: {
            issues: 5,
            points: 0,
        },
        inProgress: {
            issues: 5,
            points: 0,
        },
        done: {
            issues: 2,
            points: 0,
        },
        todoAll: {
            issues: 5,
            points: 0,
        },
        inProgressAll: {
            issues: 5,
            points: 0,
        },
        doneAll: {
            issues: 175,
            points: 0,
        },
    },
];

const timeStateDuration = [
    {
        datetime: "2025-01-02 00:00:00",
        states_avg: {
            "In progress": 10491599,
        },
        states_sum: {
            "In progress": 10491599,
        },
        details: [
            {
                url: null,
                from: "2024-09-03T16:40:00",
                until: "2025-01-07T13:27:00",
                duration: 10491599,
                overallDuration: 10878420,
                state: "In progress",
            },
        ],
    },
    {
        datetime: "2025-01-03 00:00:00",
        states_avg: {
            "In progress": 10577999,
        },
        states_sum: {
            "In progress": 10577999,
        },
        details: [
            {
                url: null,
                from: "2024-09-03T16:40:00",
                until: "2025-01-07T13:27:00",
                duration: 10577999,
                overallDuration: 10878420,
                state: "In progress",
            },
        ],
    },
    {
        datetime: "2025-01-04 00:00:00",
        states_avg: {
            "In progress": 10664399,
        },
        states_sum: {
            "In progress": 10664399,
        },
        details: [
            {
                url: null,
                from: "2024-09-03T16:40:00",
                until: "2025-01-07T13:27:00",
                duration: 10664399,
                overallDuration: 10878420,
                state: "In progress",
            },
        ],
    },
    {
        datetime: "2025-01-05 00:00:00",
        states_avg: {
            "In progress": 10750799,
        },
        states_sum: {
            "In progress": 10750799,
        },
        details: [
            {
                url: null,
                from: "2024-09-03T16:40:00",
                until: "2025-01-07T13:27:00",
                duration: 10750799,
                overallDuration: 10878420,
                state: "In progress",
            },
        ],
    },
    {
        datetime: "2025-01-06 00:00:00",
        states_avg: {
            "In progress": 10837199,
        },
        states_sum: {
            "In progress": 10837199,
        },
        details: [
            {
                url: null,
                from: "2024-09-03T16:40:00",
                until: "2025-01-07T13:27:00",
                duration: 10837199,
                overallDuration: 10878420,
                state: "In progress",
            },
        ],
    },
    {
        datetime: "2025-01-07 00:00:00",
        states_avg: {
            "In progress": 10878420,
            "Not started": 7599.833333333333,
        },
        states_sum: {
            "In progress": 10878420,
            "Not started": 91198,
        },
        details: [
            {
                url: null,
                from: "2024-09-03T16:40:00",
                until: "2025-01-07T13:27:00",
                duration: 10878420,
                overallDuration: 10878420,
                state: "In progress",
            },
            {
                from: "2025-01-07T13:20:00",
                until: "2025-01-09T12:30:00",
                duration: 45599,
                overallDuration: 169800,
                state: "Not started",
            },
            {
                url: null,
                from: "2025-01-07T13:24:00",
                until: "2025-01-07T13:24:00",
                duration: 0,
                overallDuration: 0,
                state: "Not started",
            },
            {
                from: "2025-01-07T13:21:00",
                until: "2025-01-07T13:21:00",
                duration: 0,
                overallDuration: 0,
                state: "Not started",
            },
            {
                from: "2025-01-07T13:20:00",
                until: "2025-01-07T13:20:00",
                duration: 0,
                overallDuration: 0,
                state: "Not started",
            },
            {
                from: "2025-01-07T13:20:00",
                until: "2025-01-08T12:25:00",
                duration: 45599,
                overallDuration: 83100,
                state: "Not started",
            },
            {
                url: null,
                from: "2025-01-07T13:26:00",
                until: "2025-01-07T13:26:00",
                duration: 0,
                overallDuration: 0,
                state: "Not started",
            },
            {
                from: "2025-01-07T13:22:00",
                until: "2025-01-07T13:22:00",
                duration: 0,
                overallDuration: 0,
                state: "Not started",
            },
            {
                url: null,
                from: "2025-01-07T13:24:00",
                until: "2025-01-07T13:24:00",
                duration: 0,
                overallDuration: 0,
                state: "Not started",
            },
            {
                url: null,
                from: "2025-01-07T13:25:00",
                until: "2025-01-07T13:25:00",
                duration: 0,
                overallDuration: 0,
                state: "Not started",
            },
            {
                from: "2025-01-07T13:22:00",
                until: "2025-01-07T13:22:00",
                duration: 0,
                overallDuration: 0,
                state: "Not started",
            },
            {
                from: "2025-01-07T13:23:00",
                until: "2025-01-07T13:23:00",
                duration: 0,
                overallDuration: 0,
                state: "Not started",
            },
            {
                from: "2025-01-07T13:20:00",
                until: "2025-01-07T13:20:00",
                duration: 0,
                overallDuration: 0,
                state: "Not started",
            },
        ],
    },
    {
        datetime: "2025-01-08 00:00:00",
        states_avg: {
            "In progress": 0,
            "Not started": 107549.5,
        },
        states_sum: {
            "In progress": 0,
            "Not started": 215099,
        },
        details: [
            {
                url: null,
                from: "2025-01-08T12:25:00",
                until: "2025-01-08T12:25:00",
                duration: 0,
                overallDuration: 0,
                state: "In progress",
            },
            {
                from: "2025-01-07T13:20:00",
                until: "2025-01-09T12:30:00",
                duration: 131999,
                overallDuration: 169800,
                state: "Not started",
            },
            {
                from: "2025-01-07T13:20:00",
                until: "2025-01-08T12:25:00",
                duration: 83100,
                overallDuration: 83100,
                state: "Not started",
            },
        ],
    },
    {
        datetime: "2025-01-09 00:00:00",
        states_avg: {
            "In progress": 0,
            "Not started": 169800,
        },
        states_sum: {
            "In progress": 0,
            "Not started": 169800,
        },
        details: [
            {
                url: null,
                from: "2025-01-09T12:30:00",
                until: "2025-01-09T12:30:00",
                duration: 0,
                overallDuration: 0,
                state: "In progress",
            },
            {
                from: "2025-01-07T13:20:00",
                until: "2025-01-09T12:30:00",
                duration: 169800,
                overallDuration: 169800,
                state: "Not started",
            },
        ],
    },
];

const ticketsBreakdown = [
    {
        status: "In progress",
        total: {
            issues: 3,
            points: 0,
        },
        issues: [
            {
                type: "Bug",
                value: {
                    issues: 1,
                    points: 0,
                },
            },
            {
                type: "No Type",
                value: {
                    issues: 1,
                    points: 0,
                },
            },
            {
                type: "Task",
                value: {
                    issues: 1,
                    points: 0,
                },
            },
        ],
    },
    {
        status: "To-do",
        total: {
            issues: 18,
            points: 0,
        },
        issues: [
            {
                type: "Bug",
                value: {
                    issues: 1,
                    points: 0,
                },
            },
            {
                type: "Feature",
                value: {
                    issues: 1,
                    points: 0,
                },
            },
            {
                type: "No Type",
                value: {
                    issues: 5,
                    points: 0,
                },
            },
            {
                type: "Task",
                value: {
                    issues: 10,
                    points: 0,
                },
            },
            {
                type: "Tech Debt",
                value: {
                    issues: 1,
                    points: 0,
                },
            },
        ],
    },
];

const ticketsBreakdownExpanded = [
    {
        status: "In progress",
        total: {
            issues: 1,
            points: 0,
        },
        issues: [
            {
                type: "Bug",
                value: {
                    issues: 1,
                    points: 0,
                },
            },
        ],
    },
    {
        status: "To-do",
        total: {
            issues: 11,
            points: 0,
        },
        issues: [
            {
                type: "Bug",
                value: {
                    issues: 1,
                    points: 0,
                },
            },
            {
                type: "Task",
                value: {
                    issues: 10,
                    points: 0,
                },
            },
        ],
    },
    {
        status: "Not started",
        total: {
            issues: 7,
            points: 0,
        },
        issues: [
            {
                type: "Feature",
                value: {
                    issues: 1,
                    points: 0,
                },
            },
            {
                type: "No Type",
                value: {
                    issues: 5,
                    points: 0,
                },
            },
            {
                type: "Tech Debt",
                value: {
                    issues: 1,
                    points: 0,
                },
            },
        ],
    },
    {
        status: "other in progress",
        total: {
            issues: 1,
            points: 0,
        },
        issues: [
            {
                type: "No Type",
                value: {
                    issues: 1,
                    points: 0,
                },
            },
        ],
    },
    {
        status: "QA",
        total: {
            issues: 1,
            points: 0,
        },
        issues: [
            {
                type: "Task",
                value: {
                    issues: 1,
                    points: 0,
                },
            },
        ],
    },
];

const ticketsAdded = [
    {
        datetime: "2024-05-03 00:00:00",
        Tickets: {
            issues: 0,
            points: 1,
            color: null,
        },
    },
    {
        datetime: "2024-05-04 00:00:00",
        Tickets: {
            issues: 2,
            points: 1,
            color: null,
        },
    },
    {
        datetime: "2024-05-05 00:00:00",
        Tickets: {
            issues: 0,
            points: 0,
            color: null,
        },
    },
    {
        datetime: "2024-05-06 00:00:00",
        Tickets: {
            issues: 1,
            points: 0,
            color: null,
        },
    },
    {
        datetime: "2024-05-07 00:00:00",
        Tickets: {
            issues: 2,
            points: 0,
            color: null,
        },
    },
    {
        datetime: "2024-05-08 00:00:00",
        Tickets: {
            issues: 0,
            points: 0,
            color: null,
        },
    },
    {
        datetime: "2024-05-09 00:00:00",
        Task: {
            issues: 2,
            points: 0,
            color: null,
        },
    },
];

const ticketsAssigned = [
    {
        day: "Sunday",
        min: {
            issues: 0,
            points: 0,
        },
        max: {
            issues: 0,
            points: 0,
        },
    },
    {
        day: "Monday",
        min: {
            issues: 1,
            points: 1,
        },
        max: {
            issues: 1,
            points: 1,
        },
    },
    {
        day: "Tuesday",
        min: {
            issues: 1,
            points: 0,
        },
        max: {
            issues: 4,
            points: 0,
        },
    },
    {
        day: "Wednesday",
        min: {
            issues: 1,
            points: 0,
        },
        max: {
            issues: 3,
            points: 0,
        },
    },
    {
        day: "Thursday",
        min: {
            issues: 2,
            points: 0,
        },
        max: {
            issues: 2,
            points: 3,
        },
    },
    {
        day: "Friday",
        min: {
            issues: 0,
            points: 0,
        },
        max: {
            issues: 5,
            points: 0,
        },
    },
    {
        day: "Saturday",
        min: {
            issues: 0,
            points: 0,
        },
        max: {
            issues: 0,
            points: 0,
        },
    },
];

const workDistribution = [
    {
        name: "Task",
        value: {
            issues: 15,
            points: 3,
            timeSpent: 1389,
            ticketsTimeSpent: 2,
        },
    },
    {
        name: "Features",
        value: {
            issues: 9,
            points: 5,
            timeSpent: 5339,
            ticketsTimeSpent: 1,
        },
    },
    {
        name: "Bugs",
        value: {
            issues: 3,
            points: 1,
            timeSpent: 3389,
            ticketsTimeSpent: 2,
        },
    },
];

const timeSpentEstimated = {
    timeSpentInProgress: 0,
    timeEstimatedInProgress: 0,
    timeSpentDone: 70200,
    timeEstimatedDone: 65000,
    timeSpentAll: 70200,
    timeEstimatedAll: 72220,
    tickets: [
        {
            issueKey: "MVP-2538",
            timeSpent: 14400,
            timeEstimated: 14400,
            summary: "Change installation id from hard dependency to soft ",
            issueUrl: "adadot.com",
            type: "Change",
            status: "Done",
        },
        {
            issueKey: "MVP-3027",
            timeSpent: 0,
            timeEstimated: 14400,
            summary: "fix pushing multiple entries",
            issueUrl: "adadot.com",
            type: "Change",
            status: "Done",
        },
        {
            issueKey: "MVP-763",
            timeSpent: 3600,
            timeEstimated: 14400,
            summary: "Updated size limits on text inputs",
            issueUrl: "adadot.com",
            type: "Bug",
            status: "Done",
        },
        {
            issueKey: "MVP-764",
            timeSpent: 3600,
            timeEstimated: 14400,
            summary: "Correlation advanced settings",
            issueUrl: "adadot.com",
            type: "Bug",
            status: "Done",
        },
        {
            issueKey: "MVP-789",
            timeSpent: 3600,
            timeEstimated: 14400,
            summary: "Testing new causal ai settings",
            issueUrl: "adadot.com",
            type: "Change",
            status: "InProgress",
        },
    ],
};

const stuckTickets = [
    {
        name: "MVP-703",
        title: "BE - Handle Github Draft PRs",
        url: "https://api.atlassian.com/ex/jira/8b8e0dd5-aaf8-4bea-bdfc-e236d6e7a7ce/rest/api/3/issue/10005",
        type: "Task",
        startDate: "2022-11-01 10:52:36",
    },
    {
        name: "MVP-711",
        title: "BE - Graph network discovery",
        url: "https://api.atlassian.com/ex/jira/8b8e0dd5-aaf8-4bea-bdfc-e236d6e7a7ce/rest/api/3/issue/10005",
        type: "Task",
        startDate: "2022-11-07 15:54:21",
    },
    {
        name: "MVP-678",
        title: "BE - Added/deleted/changed from commits",
        url: "https://api.atlassian.com/ex/jira/8b8e0dd5-aaf8-4bea-bdfc-e236d6e7a7ce/rest/api/3/issue/10005",
        type: "Task",
        startDate: "2022-10-10 10:02:06",
    },
];

const bugs = [
    {
        datetime: "2024-01-01 00:00:00",
        environment: "No Environment",
        created_count: 151,
        done_count: 134,
        in_backlog_count: 17,
    },
    {
        datetime: "2024-01-01 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-01 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 10,
        done_count: 10,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-01 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-01 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-01 00:00:00",
        environment: null,
        created_count: 170,
        done_count: 153,
        in_backlog_count: 17,
    },
    {
        datetime: "2024-01-01 00:00:00",
        environment: "Pre-Release",
        created_count: 5,
        done_count: 5,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-08 00:00:00",
        environment: null,
        created_count: 171,
        done_count: 157,
        in_backlog_count: 14,
    },
    {
        datetime: "2024-01-08 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-08 00:00:00",
        environment: "No Environment",
        created_count: 152,
        done_count: 138,
        in_backlog_count: 14,
    },
    {
        datetime: "2024-01-08 00:00:00",
        environment: "Pre-Release",
        created_count: 5,
        done_count: 5,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-08 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-08 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-08 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 10,
        done_count: 10,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-15 00:00:00",
        environment: null,
        created_count: 177,
        done_count: 161,
        in_backlog_count: 16,
    },
    {
        datetime: "2024-01-15 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-15 00:00:00",
        environment: "Pre-Release",
        created_count: 5,
        done_count: 5,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-15 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 10,
        done_count: 10,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-15 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-15 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-15 00:00:00",
        environment: "No Environment",
        created_count: 158,
        done_count: 142,
        in_backlog_count: 16,
    },
    {
        datetime: "2024-01-22 00:00:00",
        environment: null,
        created_count: 177,
        done_count: 167,
        in_backlog_count: 10,
    },
    {
        datetime: "2024-01-22 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-22 00:00:00",
        environment: "Pre-Release",
        created_count: 5,
        done_count: 5,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-22 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-22 00:00:00",
        environment: "No Environment",
        created_count: 158,
        done_count: 148,
        in_backlog_count: 10,
    },
    {
        datetime: "2024-01-22 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 10,
        done_count: 10,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-22 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-29 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 11,
        done_count: 10,
        in_backlog_count: 1,
    },
    {
        datetime: "2024-01-29 00:00:00",
        environment: null,
        created_count: 180,
        done_count: 167,
        in_backlog_count: 13,
    },
    {
        datetime: "2024-01-29 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-29 00:00:00",
        environment: "No Environment",
        created_count: 160,
        done_count: 148,
        in_backlog_count: 12,
    },
    {
        datetime: "2024-01-29 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-29 00:00:00",
        environment: "Pre-Release",
        created_count: 5,
        done_count: 5,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-29 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-05 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-05 00:00:00",
        environment: "No Environment",
        created_count: 163,
        done_count: 150,
        in_backlog_count: 13,
    },
    {
        datetime: "2024-02-05 00:00:00",
        environment: "Pre-Release",
        created_count: 5,
        done_count: 5,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-05 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-05 00:00:00",
        environment: null,
        created_count: 183,
        done_count: 170,
        in_backlog_count: 13,
    },
    {
        datetime: "2024-02-05 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 11,
        done_count: 11,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-05 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-12 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-12 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 11,
        done_count: 11,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-12 00:00:00",
        environment: "No Environment",
        created_count: 166,
        done_count: 151,
        in_backlog_count: 15,
    },
    {
        datetime: "2024-02-12 00:00:00",
        environment: null,
        created_count: 186,
        done_count: 171,
        in_backlog_count: 15,
    },
    {
        datetime: "2024-02-12 00:00:00",
        environment: "Pre-Release",
        created_count: 5,
        done_count: 5,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-12 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-12 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-19 00:00:00",
        environment: "Pre-Release",
        created_count: 5,
        done_count: 5,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-19 00:00:00",
        environment: "No Environment",
        created_count: 169,
        done_count: 158,
        in_backlog_count: 11,
    },
    {
        datetime: "2024-02-19 00:00:00",
        environment: null,
        created_count: 189,
        done_count: 178,
        in_backlog_count: 11,
    },
    {
        datetime: "2024-02-19 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-19 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-19 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 11,
        done_count: 11,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-19 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-26 00:00:00",
        environment: "No Environment",
        created_count: 171,
        done_count: 160,
        in_backlog_count: 11,
    },
    {
        datetime: "2024-02-26 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-26 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-26 00:00:00",
        environment: null,
        created_count: 191,
        done_count: 180,
        in_backlog_count: 11,
    },
    {
        datetime: "2024-02-26 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 11,
        done_count: 11,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-26 00:00:00",
        environment: "Pre-Release",
        created_count: 5,
        done_count: 5,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-26 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-04 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 11,
        done_count: 11,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-04 00:00:00",
        environment: null,
        created_count: 196,
        done_count: 181,
        in_backlog_count: 15,
    },
    {
        datetime: "2024-03-04 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-04 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-04 00:00:00",
        environment: "Pre-Release",
        created_count: 5,
        done_count: 5,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-04 00:00:00",
        environment: "No Environment",
        created_count: 176,
        done_count: 161,
        in_backlog_count: 15,
    },
    {
        datetime: "2024-03-04 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-11 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-11 00:00:00",
        environment: null,
        created_count: 199,
        done_count: 186,
        in_backlog_count: 13,
    },
    {
        datetime: "2024-03-11 00:00:00",
        environment: "No Environment",
        created_count: 178,
        done_count: 165,
        in_backlog_count: 13,
    },
    {
        datetime: "2024-03-11 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-11 00:00:00",
        environment: "Pre-Release",
        created_count: 5,
        done_count: 5,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-11 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-11 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-18 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-18 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-18 00:00:00",
        environment: "Pre-Release",
        created_count: 5,
        done_count: 5,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-18 00:00:00",
        environment: "No Environment",
        created_count: 185,
        done_count: 166,
        in_backlog_count: 19,
    },
    {
        datetime: "2024-03-18 00:00:00",
        environment: null,
        created_count: 206,
        done_count: 187,
        in_backlog_count: 19,
    },
    {
        datetime: "2024-03-18 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-18 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-25 00:00:00",
        environment: "No Environment",
        created_count: 187,
        done_count: 173,
        in_backlog_count: 14,
    },
    {
        datetime: "2024-03-25 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-25 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 5,
        in_backlog_count: 1,
    },
    {
        datetime: "2024-03-25 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-25 00:00:00",
        environment: null,
        created_count: 209,
        done_count: 194,
        in_backlog_count: 15,
    },
    {
        datetime: "2024-03-25 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-25 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-01 00:00:00",
        environment: null,
        created_count: 210,
        done_count: 194,
        in_backlog_count: 16,
    },
    {
        datetime: "2024-04-01 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-01 00:00:00",
        environment: "No Environment",
        created_count: 188,
        done_count: 173,
        in_backlog_count: 15,
    },
    {
        datetime: "2024-04-01 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 5,
        in_backlog_count: 1,
    },
    {
        datetime: "2024-04-01 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-01 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-01 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-08 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-08 00:00:00",
        environment: "No Environment",
        created_count: 196,
        done_count: 178,
        in_backlog_count: 18,
    },
    {
        datetime: "2024-04-08 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-08 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-08 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-08 00:00:00",
        environment: null,
        created_count: 218,
        done_count: 199,
        in_backlog_count: 19,
    },
    {
        datetime: "2024-04-08 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 5,
        in_backlog_count: 1,
    },
    {
        datetime: "2024-04-15 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-15 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-15 00:00:00",
        environment: "No Environment",
        created_count: 198,
        done_count: 178,
        in_backlog_count: 20,
    },
    {
        datetime: "2024-04-15 00:00:00",
        environment: null,
        created_count: 220,
        done_count: 199,
        in_backlog_count: 21,
    },
    {
        datetime: "2024-04-15 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-15 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-15 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 5,
        in_backlog_count: 1,
    },
    {
        datetime: "2024-04-22 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-22 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-22 00:00:00",
        environment: null,
        created_count: 223,
        done_count: 204,
        in_backlog_count: 19,
    },
    {
        datetime: "2024-04-22 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 5,
        in_backlog_count: 1,
    },
    {
        datetime: "2024-04-22 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-22 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-22 00:00:00",
        environment: "No Environment",
        created_count: 201,
        done_count: 183,
        in_backlog_count: 18,
    },
    {
        datetime: "2024-04-29 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-29 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-29 00:00:00",
        environment: "No Environment",
        created_count: 201,
        done_count: 190,
        in_backlog_count: 11,
    },
    {
        datetime: "2024-04-29 00:00:00",
        environment: null,
        created_count: 223,
        done_count: 211,
        in_backlog_count: 12,
    },
    {
        datetime: "2024-04-29 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-29 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 5,
        in_backlog_count: 1,
    },
    {
        datetime: "2024-04-29 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-06 00:00:00",
        environment: null,
        created_count: 228,
        done_count: 212,
        in_backlog_count: 16,
    },
    {
        datetime: "2024-05-06 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-06 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 5,
        in_backlog_count: 1,
    },
    {
        datetime: "2024-05-06 00:00:00",
        environment: "No Environment",
        created_count: 206,
        done_count: 191,
        in_backlog_count: 15,
    },
    {
        datetime: "2024-05-06 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-06 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-06 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-13 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-13 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-13 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-13 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-13 00:00:00",
        environment: "No Environment",
        created_count: 207,
        done_count: 192,
        in_backlog_count: 15,
    },
    {
        datetime: "2024-05-13 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 6,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-13 00:00:00",
        environment: null,
        created_count: 229,
        done_count: 214,
        in_backlog_count: 15,
    },
    {
        datetime: "2024-05-20 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 6,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-20 00:00:00",
        environment: null,
        created_count: 231,
        done_count: 217,
        in_backlog_count: 14,
    },
    {
        datetime: "2024-05-20 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-20 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-20 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-20 00:00:00",
        environment: "No Environment",
        created_count: 209,
        done_count: 195,
        in_backlog_count: 14,
    },
    {
        datetime: "2024-05-20 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-27 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-27 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-27 00:00:00",
        environment: "No Environment",
        created_count: 213,
        done_count: 201,
        in_backlog_count: 12,
    },
    {
        datetime: "2024-05-27 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 6,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-27 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-27 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-27 00:00:00",
        environment: null,
        created_count: 235,
        done_count: 223,
        in_backlog_count: 12,
    },
    {
        datetime: "2024-06-03 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-03 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-03 00:00:00",
        environment: "No Environment",
        created_count: 219,
        done_count: 207,
        in_backlog_count: 12,
    },
    {
        datetime: "2024-06-03 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-03 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-03 00:00:00",
        environment: null,
        created_count: 241,
        done_count: 229,
        in_backlog_count: 12,
    },
    {
        datetime: "2024-06-03 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 6,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-10 00:00:00",
        environment: null,
        created_count: 243,
        done_count: 230,
        in_backlog_count: 13,
    },
    {
        datetime: "2024-06-10 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-10 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-10 00:00:00",
        environment: "No Environment",
        created_count: 221,
        done_count: 208,
        in_backlog_count: 13,
    },
    {
        datetime: "2024-06-10 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 6,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-10 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-10 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-17 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-17 00:00:00",
        environment: null,
        created_count: 245,
        done_count: 231,
        in_backlog_count: 14,
    },
    {
        datetime: "2024-06-17 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-17 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-17 00:00:00",
        environment: "No Environment",
        created_count: 223,
        done_count: 209,
        in_backlog_count: 14,
    },
    {
        datetime: "2024-06-17 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 6,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-17 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-24 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 6,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-24 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-24 00:00:00",
        environment: null,
        created_count: 249,
        done_count: 233,
        in_backlog_count: 16,
    },
    {
        datetime: "2024-06-24 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-24 00:00:00",
        environment: "No Environment",
        created_count: 227,
        done_count: 211,
        in_backlog_count: 16,
    },
    {
        datetime: "2024-06-24 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-24 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-01 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-01 00:00:00",
        environment: "No Environment",
        created_count: 232,
        done_count: 215,
        in_backlog_count: 17,
    },
    {
        datetime: "2024-07-01 00:00:00",
        environment: null,
        created_count: 254,
        done_count: 237,
        in_backlog_count: 17,
    },
    {
        datetime: "2024-07-01 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-01 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-01 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-01 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 6,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-08 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 6,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-08 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-08 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-08 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-08 00:00:00",
        environment: "No Environment",
        created_count: 235,
        done_count: 216,
        in_backlog_count: 19,
    },
    {
        datetime: "2024-07-08 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-08 00:00:00",
        environment: null,
        created_count: 257,
        done_count: 238,
        in_backlog_count: 19,
    },
    {
        datetime: "2024-07-15 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-15 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-15 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-15 00:00:00",
        environment: null,
        created_count: 260,
        done_count: 242,
        in_backlog_count: 18,
    },
    {
        datetime: "2024-07-15 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 6,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-15 00:00:00",
        environment: "No Environment",
        created_count: 238,
        done_count: 220,
        in_backlog_count: 18,
    },
    {
        datetime: "2024-07-15 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-22 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-22 00:00:00",
        environment: null,
        created_count: 261,
        done_count: 242,
        in_backlog_count: 19,
    },
    {
        datetime: "2024-07-22 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-22 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 6,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-22 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-22 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-22 00:00:00",
        environment: "No Environment",
        created_count: 239,
        done_count: 220,
        in_backlog_count: 19,
    },
];

const meta = {
    inactive: false,
    lastActiveAt: 1653523200,
    firstScrappedDate: 1650412800,
};

const stats = {
    backlogSize: {
        issues: 7,
        points: null,
    },
    ticketsTransitioned: {
        uniqueIssues: 4,
        transitions: {
            issues: 9,
            points: 0,
        },
    },
    arrivalRate: {
        issues: 0.29,
        points: 0,
    },
    departureRate: {
        issues: 0.29,
        points: 0,
    },
    avgCycleTime: 2825943,
    avgThroughput: {
        issues: 2,
        points: 0,
    },
};

const statsBaseline = {
    backlogSize: {
        issues: 18.93,
        points: 0,
    },
    ticketsTransitioned: {
        uniqueIssues: 3.53,
        transitions: {
            issues: 6.47,
            points: 0,
        },
    },
    arrivalRate: {
        issues: 0.11,
        points: 0,
    },
    departureRate: {
        issues: 0,
    },
    avgCycleTime: 2898811.85,
    avgThroughput: {
        issues: 1.17,
        points: 0,
    },
};

const getSprintBreakdown = () => {
    return {
        ticketsAssigned,
        timeSpentEstimated,
        stuckTickets,
        ticketsOverview,
        workDistribution,
        ticketsAdded,
        ticketsBreakdown: {
            simple: ticketsBreakdown,
            expanded: ticketsBreakdownExpanded,
        },
        bugs,
        stats,
        statsBaseline,
        timeStateDuration,
        meta,
    };
};

export default getSprintBreakdown;
